<ion-item>
  <ion-input (ionFocus)="openSearch()" type="text" [(ngModel)]="displayValue" [required]="required"
    [disabled]="disabled" #searchInput>
    <ion-label slot="label" color="primary" position="fixed">{{ label }}
      @if (required) {
      <ion-text color="danger">&nbsp;*</ion-text>
      }
    </ion-label>
  </ion-input>
</ion-item>